import {useRequestURL} from '#app';
import { useAuthService } from '~/composables/useAuthService';
import {pageBeingRendered, sessionFreeRoute, sessionStarterAfter} from '~/utils/sessionFreeRoutes';
export default defineNuxtPlugin(async (nuxtApp) => {
    const { init } = useAuthService();

    // Initialize auth state before middleware runs
    // This reads cookies and sets up state for middleware to use.
    // A session free page (the anonymous feedback page) reads the state and nothing more: no
    // /auth/me refresh, no live connection, no sign in header (see sessionFreeRoutes). The path
    // is the page being rendered, on the server and in the browser, since the router has not
    // settled yet. On the server that is the render's own url: Nuxt renders a server error a second
    // time at /__nuxt_error with the visitor's cookies, and that render is still the failing page.
    const initialPath = pageBeingRendered(useRequestURL(), nuxtApp.ssrContext?.url);
    await init({session: !sessionFreeRoute(initialPath)});

    // Leaving a session free page within the app (the 404 page's "Go home", a link, back) starts
    // the session once, before the next page's middleware runs, as a normal page load would.
    if (import.meta.client) {
        const startOnMove = sessionStarterAfter(initialPath, () => init({session: true}));
        nuxtApp.$router.beforeEach(async (to) => {
            await startOnMove(to.path);
        });
    }
});
